import script from "./IniFileTdSensorSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./IniFileTdSensorSetting.vue?vue&type=script&setup=true&lang=js"

import "./IniFileTdSensorSetting.vue?vue&type=style&index=0&id=3c2610e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c2610e8"]])

export default __exports__